import { get, post } from '../../utils/http';

export const fetchPayrollOverview = ({ accountId, from, to }) =>
  get(`/accounts/${accountId}/dashboard/account/payroll`, { from, to });

export const fetchBranchesOverview = ({ accountId, from, to }) =>
  get(`/accounts/${accountId}/dashboard/branches/payroll`, { from, to });

export const fetchEmployeesOverview = ({ accountId, from, to }) =>
  get(`/accounts/${accountId}/dashboard/employees/milestones`, { from, to });

export const fetchBranchesLocations = ({ accountId }) => get(`/accounts/${accountId}/dashboard/locations`);

export const enableRevenue = ({ accountId }) => post(`/accounts/${accountId}/dashboard/revenue`);

export const fetchAccountOverview = ({ accountId }) => get(`/accounts/${accountId}/dashboard/steps`);
